import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 船组颜色
 */
class Color extends UltMeta {
    ONE = new Meta(1, "#FFB23F");
    TWO = new Meta(2, "#FFF73F");
    THREE = new Meta(3, "#B4FFF6");
    FOUR = new Meta(4, "#2C9AFF");
    FIVE = new Meta(5, "#A098FF");
    SIX = new Meta(6, "#FFA8EC");
    SEVEN = new Meta(7, "#08246C");
    EIGHT = new Meta(8, "#FF8C39");
    NINE = new Meta(9, "#BC5900");
    TEN = new Meta(10, "#B9EEFF");
    ELEVEN = new Meta(11, "#D634FF");
    TWELVE = new Meta(12, "#3AF5DF");
    /**
     * 固定组 颜色
     */
    THIRTEEN = new Meta(13, "#8D15B7");
    FOURTEEN = new Meta(14, "#4437DA");
    FIFTEEN = new Meta(15, "#7E7025");
    SIXTEEN = new Meta(16, "#18A2A2");
}

export const COLOR = new Color();
